import { UsercryptChoiceImage } from '@calm/evexia-web-sdk';
import { DynamicIcon } from '@rhg/components/dynamic-icon';
import { ZenFilled, ZenOutline } from '@rhg/libs/material/icons';

export function UsercryptChoiceIcon({
    image,
    isSelected = false,
    isDisabled = false,
}: {
    image?: UsercryptChoiceImage;
    isSelected?: boolean;
    isDisabled?: boolean;
}) {
    const src = (isSelected ? image?.filledUrl : image?.url) ?? '';

    if (!src) {
        return isSelected ? <ZenFilled /> : <ZenOutline />;
    }

    return (
        <DynamicIcon
            src={src}
            color={
                isSelected
                    ? 'primary.contrastText'
                    : isDisabled
                    ? 'text.disabled'
                    : 'text.primary'
            }
        />
    );
}
